<template>
  <div class="ps-px-6 ps-bg-white ps-mt-6 ps-py-6">
    <div class="ps-mb-2">
      <img
        src="https://cdn1.gbot.me/photos/nd/xJ/1407702857/-_Summer_Activities_in_My_-20000000008276292-500x375.jpg"
      />
    </div>
    <a
      href="#"
      class="ps-flex ps-items-center ps-no-underline ps-text-brand-brown-800 ps-mt-2"
    >
      <span class="ps-flex-auto">
        <h5 class="ps-text-base">filename.jpg</h5>
        <p class="ps-text-xs  ps-mt-1">3 minutes ago</p>
      </span>
      <span class="ps-w-4 ps-svg-left ps-mx-4">
        <svg-icon name="go" width="100%" height="auto" />
      </span>
    </a>
  </div>
</template>

<script>
import '@/icons/go'

export default {
  name: 'ItemFile',
  props: {
    msg: String
  }
}
</script>
